var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:'LazyImage ' + _vm.lazyClass,style:(_vm.style),attrs:{"data-src":_vm.lazySrc,"data-srcset":_vm.lazySrcset,"alt":_vm.lazyAlt}})}
var staticRenderFns = []

export { render, staticRenderFns }